import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { H4, H6, P } from "../../../../../AbstractElements";
import { TotalVisitorTitle } from "../../../../../Constants/Constants";
import ReactApexChart from "react-apexcharts";
import { TotalVisitorChart } from "../../../../../Data/General/Widgets/General";

const TotalVisitor = () => {
  return (
    <Col xl="3" sm="6">
      <Card className="overflow-hidden">
        <CardBody className="total-sale visitor px-0">
          <div className="d-flex align-items-center gap-2">
            <div className="bg-icon bg-light-secondary">
              <div className="flex-shrink-0 bg-light-secondary">
                <SvgIcon iconId="user" />
              </div>
            </div>
            <div className="flex-grow-1">
              <div className="d-flex align-items-center">
                <H4>$42.685</H4>
                <span className="text-truncate">{TotalVisitorTitle}</span>
                <div className="total-icon mt-1">
                  <P className="mb-0 up-arrow bg-light-success me-1">
                    <i className="fa fa-arrow-up text-success" />
                  </P>
                  <span className="f-w-500 font-success me-1">+ 6.3% </span>
                  <H6>Than last week</H6>
                </div>
              </div>
            </div>
          </div>
          <div id="visit-chart">
            <ReactApexChart options={TotalVisitorChart} series={TotalVisitorChart.series} height={105} type="bar"/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TotalVisitor;
